module.exports = __webpack_public_path__ + "static/type-brigade-50-CommercialClassics13-480bf0862e2c010208cb75eac0c30f49.jpg";